// Package Imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ResourceService {
  constructor(private http: HttpClient) { }

  getDictionary(fileName: string = '', language: string = 'en-us', fileType: string = 'dictionary-resources'): Observable<any> {
    const url = `./assets/${fileType}/${language}${fileName.trim() !== '' ? '.' + fileName + '.json' : '.json'}`;

    return this.http.get(url).pipe(map((response: any) => response));
  }
}
